var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgRiskSport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.7266 57.6369V76.4572H8.27344V57.6369C8.27344 45.666 13.9334 34.592 22.7404 27.1562L47.7892 40.9199L48 40.8146L73.2596 27.1562C82.0666 34.592 87.7266 45.666 87.7266 57.6369Z",
    fill: "#D6E8F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7266 57.6369C87.7266 63.7892 87.7266 69.9416 87.7266 76.0939H48V40.8146L73.2596 27.1562C82.0666 34.592 87.7266 45.666 87.7266 57.6369Z",
    fill: "#B0D2EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7266 75.8203H8.27344L4.27344 78.5V80.3672C4.27344 80.3672 18.5 89.3672 48 89.3672C77.5 89.3672 91.7266 80.3672 91.7266 80.3672V78.5938L87.7266 75.8203Z",
    fill: "#D6E8F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7266 75.8203H48V89.3672C77.5 89.3672 91.7266 80.3672 91.7266 80.3672V78.5938L87.7266 75.8203Z",
    fill: "#B0D2EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7266 78.3672C91.7266 75.856 89.6909 73.8203 87.1797 73.8203H8.82031C6.30914 73.8203 4.27344 75.856 4.27344 78.3672C4.27344 78.3672 31 81.3672 48 81.3672C65 81.3672 91.7266 78.3672 91.7266 78.3672Z",
    fill: "#B0D2EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7266 78.3672C91.7266 75.856 89.6909 73.8203 87.1797 73.8203H48V81.3672C65 81.3672 91.7266 78.3672 91.7266 78.3672Z",
    fill: "#4B81AC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8104 19.5625C58.5996 19.5098 53.3262 19.5098 47.9998 19.5098C42.6735 19.5098 37.3473 19.5098 37.1893 19.5625C31.8631 21.0916 26.9061 23.7283 22.7402 27.1559L28.4881 44.2946C29.5428 47.5641 32.5487 49.7264 35.9762 49.7264H60.0234C63.451 49.7264 66.4569 47.5641 67.5115 44.2946L73.2594 27.1559C69.1463 23.834 64.0838 21.0389 58.8104 19.5625Z",
    fill: "#B0D2EC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0236 49.7264H48V19.5098C53.3262 19.5098 58.5996 19.5098 58.8105 19.5625C64.084 21.0389 69.1467 23.834 73.2598 27.1559L67.5117 44.2946C66.457 47.5641 63.4512 49.7264 60.0236 49.7264Z",
    fill: "#4B81AC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8059 15.1855C54.1165 13.6035 51.058 12.8125 47.9995 12.8125C44.9409 12.8125 41.8824 13.6037 39.193 15.1855C36.3451 16.873 34.8158 20.1953 35.5016 23.5178L40.5641 49.7266H55.4348L60.4975 23.5178C61.1831 20.1955 59.6539 16.8732 56.8059 15.1855Z",
    fill: "#D6E8F6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4354 49.7266H48V12.8125C51.0588 12.8125 54.117 13.6037 56.8065 15.1855C59.6543 16.873 61.1836 20.1953 60.4979 23.5178L55.4354 49.7266Z",
    fill: "#B0D2EC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 22,
    r: 17,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 22,
    r: 13,
    fill: "#E23E5C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 14,
    width: 4,
    height: 10,
    rx: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 26,
    width: 4,
    height: 4,
    rx: 2,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgRiskSport);
export default __webpack_public_path__ + "static/media/imgRiskSport.c5d8459867fc0d5519e365b0a9030ccf.svg";
export { ForwardRef as ReactComponent };